import { COLOMBIA_ONBOARDING_STEPS } from '.';

export const STAGE_STEPS = {
  BANK_INFORMATION: 'account',
  DOCUMENTS: 'documents',
  STAKEHOLDERS: 'complete',
};

export const FORM_STEP_FIELDS = {
  [COLOMBIA_ONBOARDING_STEPS.BANK_INFORMATION]: STAGE_STEPS.BANK_INFORMATION,
  [COLOMBIA_ONBOARDING_STEPS.COMPANY_DOCUMENTATION]: STAGE_STEPS.DOCUMENTS,
  [COLOMBIA_ONBOARDING_STEPS.STAKEHOLDERS]: STAGE_STEPS.STAKEHOLDERS,
};
